export * from './ShapeTriangleUpIcon';
export * from './ShapeTriangleUpIcon16Light';
export * from './ShapeTriangleUpIcon16Regular';
export * from './ShapeTriangleUpIcon16Solid';
export * from './ShapeTriangleUpIcon20Light';
export * from './ShapeTriangleUpIcon20Regular';
export * from './ShapeTriangleUpIcon20Solid';
export * from './ShapeTriangleUpIcon24Regular';
export * from './ShapeTriangleUpIcon24Solid';
export * from './ShapeTriangleUpIcon32Regular';
export * from './ShapeTriangleUpIcon64Regular';
